import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const Results = ({ 
  question, 
  questionLength, 
  currentQuestionNum, 
  isCorrect, 
  nextQuestion, 
  returnHome 
}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.zoom = '1';
  }, []);

  // コードブロックを表示する関数
  const renderCode = (code) => {
    if (!code || code.length === 0) return null;
    return (
      <pre>
        <code className="java">
          {code.map((line, index) => (
            <React.Fragment key={index}>
              {line}
              {'\n'}
            </React.Fragment>
          ))}
        </code>
      </pre>
    );
  };

  return (
    <div className="results-container card">
      <header className="result-header">
        <h1>結果</h1>
        <h2>問題 No.{question.number}</h2>
        <div className="quiz-progress">
          <progress value={currentQuestionNum} max={questionLength} />
          <div>{currentQuestionNum}/{questionLength}問</div>
        </div>
      </header>

      <div className="result-content">
        <div className={`result-status ${isCorrect ? 'correct' : 'incorrect'}`}>
          {isCorrect ? '正解！' : '不正解'}
        </div>

        <div className="question-section">
          <h3>問題</h3>
          {question['previous-code'] && renderCode(question['previous-code'])}
          <p className="question-text">{question.question}</p>
          {question['following-code'] && renderCode(question['following-code'])}
        </div>

        <div className="answer-section">
          <h3>解答と解説</h3>
          {question.choices.map((choice, index) => (
            choice && (
              <React.Fragment key={index}>
                <div 
                  className={`answer-item ${question.correct.includes(choice) ? 'correct-answer' : ''}`}
                >
                  <span className="choice-label">{String.fromCharCode(65 + index)}.</span>
                  {choice}
                </div>
                {question.descriptions[index] && (
                  <p className="description-text">
                    {question.descriptions[index]}
                  </p>
                )}
              </React.Fragment>
            )
          ))}
          
          {question.jpnURL && (
            <a 
              href={question.jpnURL} 
              className="reference-link" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              参考問題ページ
            </a>
          )}
        </div>

        <div className="action-buttons">
          <button onClick={nextQuestion} className="button">
            次の問題
          </button>
          <button onClick={returnHome} className="button button-secondary">
            ホームに戻る
          </button>
        </div>
      </div>
    </div>
  );
};

Results.propTypes = {
  question: PropTypes.shape({
    number: PropTypes.string.isRequired,
    question: PropTypes.string.isRequired,
    choices: PropTypes.arrayOf(PropTypes.string).isRequired,
    correct: PropTypes.arrayOf(PropTypes.string).isRequired,
    descriptions: PropTypes.arrayOf(PropTypes.string),
    'previous-code': PropTypes.arrayOf(PropTypes.string),
    'following-code': PropTypes.arrayOf(PropTypes.string),
    jpnURL: PropTypes.string
  }).isRequired,
  questionLength: PropTypes.number.isRequired,
  currentQuestionNum: PropTypes.number.isRequired,
  isCorrect: PropTypes.bool.isRequired,
  nextQuestion: PropTypes.func.isRequired,
  returnHome: PropTypes.func.isRequired
};

export default Results;
